import { render, staticRenderFns } from "./balanceAccount.vue?vue&type=template&id=6dfda1e7&scoped=true&"
import script from "./balanceAccount.vue?vue&type=script&lang=js&"
export * from "./balanceAccount.vue?vue&type=script&lang=js&"
import style0 from "./balanceAccount.vue?vue&type=style&index=0&id=6dfda1e7&prod&lang=scss&scoped=true&"
import style1 from "./balanceAccount.vue?vue&type=style&index=1&id=6dfda1e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfda1e7",
  null
  
)

export default component.exports